import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../../shared';
import { ClienteContratoFormComponent } from './cliente-contrato-form.component';

@NgModule({
  imports: [
    SharedModule
  ],
  declarations: [
    ClienteContratoFormComponent
  ],
  exports: [
    ClienteContratoFormComponent
  ]
})
export class ClienteContratoFormModule {}
